<template>
  <div>
    <div id="main-content" :key="entry.text" v-for="entry in texts">
      <TextContainer
        v-if="entry.text.length < 700"
        :src="entry.imgPath"
        v-bind:id="entry.id"
        v-bind:content="entry.text"
        v-bind:orientation="entry.orientation"
        v-bind:title="entry.title"
      />

      <BigTextContainer
        v-else
        :src="entry.imgPath"
        v-bind:id="entry.id"
        v-bind:content="entry.text"
        v-bind:orientation="entry.orientation"
        v-bind:title="entry.title"
      />
    </div>
  </div>
</template>

<script>
import TextContainer from "../components/TextContainer";
import BigTextContainer from "../components/BigTextContainer";
export default {
  name: "About",
  components: {
    BigTextContainer,
    TextContainer
  },
  data() {
    return {
      page: "about",
      texts: [],
      texts2: [
        {
          title: "Waarom de Bob Vlake Foundation?",
          text: `
                <p>Waarom wil iemand  op hoge leeftijd ( 85 jaar ) financiële middelen en energie steken in een Goede Doelen fonds. Het antwoord is simpel:  ik wil iets aan de samenleving nalaten.</p>
                <p>Dit omdat ik veel aan de samenleving te danken heb. Door onderwijs van basisschool tot universiteit heb ik kennis opgedaan, die mij in staat stelde op verschillende posities in bedrijfsleven en bij de overheid werkzaam te zijn .Het ging er mij om een zinvolle bijdrage te leveren in het samenspel van mens en maatschappij.</p>
                <p>Daarnaast  waren er ook vele moeilijke periodes in mijn leven waarin medici al hun kennis in de behandeling van soms ernstige ziektes moesten toepassen, en het zorgzame verplegend personeel op invoelende wijze mij terzijde stond en mij er bovenop hielp. Een kritieke situatie te boven komen is een  ervaring, die dankbaar stemt, ook en vooral tegenover al diegenen, die zich voor mij hebben ingezet.</p>
      <p>Daarom voel ik mij bevoorrecht, en grijp de kans om, nu het nog kan, een bijdrage te leveren aan de oplossing van belangrijke maatschappelijke problemen. Het gaat om een gezonde, leefbare toekomst voor iedereen. Daarin moeten we samen veel denkkracht en energie steken.
      Bij de opzet en ontwikkeling van de Bob Vlake Foundation werk ik samen met 2 inspirerende jonge mensen, even enthousiast als ik,  mijn vrienden Koen Hobelman en Floris van Luttervelt. Bij hen weet ik t.z.t. en gedurende vele jaren later, de Foundation in goede handen .`,
          imgPath: "/static/img/bob.png",
          imgFooter: "© Foto Ernst Coppejans",
          highlighted: true,
          orientation: true
        },
        {
          title: "Bijdragen?",
          text: `Wij werken toe naar een bredere basis van deze foundation en worden gesteund door vele die zich herkennen in de
          onderwerpen. Mensen dragen al bij door ideeën te delen en hun kennis ter beschikking te stellen. Ook donaties en giften zijn
          zeer welkom. Op een andere manier bijdragen of een leuk idee? <a href="/contact">Laat het ons weten</a>.`,
          imgPath: null,
          orientation: true
        }
      ]
    };
  },
  created() {
    this.$api
      .get(`/maintext/page/${this.page}`)
      .then(response => (this.texts = response.data));
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/About.vue